import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_maritime-solutions-10/artifacts/h1jjjufd_198E4AA3-70F6-4777-87F5-0FD635CD976A.png";

/**
 * Logo component
 * variant:
 *  - "navbar"  : compact emblem + wordmark for the sticky header
 *  - "footer"  : larger framed presentation for dark backgrounds
 *  - "mark"    : just the image (no frame)
 */
export default function Logo({ variant = "navbar" }) {
  if (variant === "footer") {
    return (
      <a
        href="#hero"
        data-testid="logo-link-footer"
        className="inline-block group"
        aria-label="KMS Services Plus"
      >
        <div className="bg-white p-4 sm:p-5 shadow-2xl ring-1 ring-white/20 transition-transform duration-500 group-hover:-translate-y-1">
          <img
            src={LOGO_URL}
            alt="KMS Services Plus"
            className="h-20 sm:h-24 w-auto object-contain"
          />
        </div>
      </a>
    );
  }

  if (variant === "mark") {
    return (
      <img
        src={LOGO_URL}
        alt="KMS Services Plus"
        className="h-full w-auto object-contain"
      />
    );
  }

  // navbar (default) - clean compact emblem (image already contains brand text)
  return (
    <a
      href="#hero"
      data-testid="logo-link"
      className="flex items-center group"
      aria-label="KMS Services Plus"
    >
      <div className="relative bg-white border border-[#0A1128]/10 px-2 py-1 transition-all duration-300 group-hover:border-[#D90429] group-hover:shadow-lg">
        <img
          src={LOGO_URL}
          alt="KMS Services Plus"
          className="h-11 sm:h-12 w-auto object-contain"
        />
        <span className="absolute -bottom-1 -right-1 w-2 h-2 bg-[#D90429] opacity-0 group-hover:opacity-100 transition-opacity" />
      </div>
    </a>
  );
}
